import { IconButton } from "@mui/material";
import {
  Datagrid,
  DateField,
  TextField,
  FunctionField,
  ListContextProvider,
  useRecordContext,
  useLocaleState,
  useList,
  useGetList,
  useTranslate,
  WrapperField,
} from "react-admin";
import CustomActionLink from "shared/components/CustomActionLink";
import VisibilityIcon from "@mui/icons-material/Visibility";

export const ImagingStudyList = (props) => {
  const patient = useRecordContext();
  const t = useTranslate();
  const [locale] = useLocaleState();
  const imagingStudyList = patient?.studies;
  const listContext = useList({
    data: imagingStudyList,
    sort: { field: "exam_date", order: "DESC" },
  });
  const isAnalysisDone = ["done", "cached"].includes(patient?.analysis?.status);

  const onRowClick = (id, resource, imagingStudyRecord) => {
    const studyId = imagingStudyRecord.uid;
    const exam_date = imagingStudyRecord.exam_date;

    return `${patient.id}/studies/${studyId}?exam_date=${encodeURIComponent(
      exam_date,
    )}`;
  };

  return (
    <ListContextProvider value={listContext}>
      <Datagrid
        bulkActionButtons={false}
        hover={isAnalysisDone}
        rowClick={isAnalysisDone ? onRowClick : undefined}
      >
        <DateField
          source="exam_date"
          locales={locale}
          label={t("resource.imagingstudies.startDate")}
          sortable
          options={{
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          }}
        />
        <TextField
          source="description"
          sortable
          label={t("resource.imagingstudies.description")}
        />
        <TextField
          source="device"
          sortable
          label={t("resource.devices.name")}
        />
        <FunctionField
          source="modalities"
          label={t("resource.imagingstudies.modality")}
          render={(record) =>
            [...new Set(record.modalities?.sort().filter(Boolean))].join(", ")
          }
        />
        <FunctionField
          source="sequence_types"
          label={t("resource.imagingstudies.sequence_type")}
          render={(record) =>
            [...new Set(record.sequence_types?.sort().filter(Boolean))].join(
              ", ",
            )
          }
        />
        <WrapperField
          label="Actions"
          cellClassName="w-8 text-blue-500 !py-1 !pr-5 text-right"
        >
          <CustomActionLink
            title={t("resources.analyses.tooltip.view")}
            aria-label={t("resources.analyses.tooltip.view")}
            getPath={(record) =>
              `/patients/${patient.id}/studies/${
                record.uid
              }?exam_date=${encodeURIComponent(record.exam_date)}`
            }
            hidden={!isAnalysisDone}
          >
            <IconButton size="small" color="primary">
              <VisibilityIcon fontSize="small" />
            </IconButton>
          </CustomActionLink>
        </WrapperField>
      </Datagrid>
    </ListContextProvider>
  );
};
